export enum WHATISMOD {
    SAVE = 'Save',
    STAT = 'Stat',
    TOHIT = 'ToHit',
    SKILL = 'Skill',
    ARMOR = 'Armor',
}